import { useIsProcurementModuleEnabled } from '@/src/hooks/location-module/location-module.hooks'
import { isBase, isLocal } from '@shared/utils'
import { useFeatureFlagEnabled as usePosthogFeatureFlagEnabled } from 'posthog-js/react'
import { FeatureFlags } from './feature-flag.const'

// For detailed notes on how to use feature flags, please consult: https://www.notion.so/ecoplanet/Feature-flag-implementation-1d6182495b0980e0842cc1da36bc1e68#1ed182495b098066a7f8c27d2a3cae27
const useFeatureFlagEnabled = (flag: string) => {
  return usePosthogFeatureFlagEnabled(flag)
}

// To add a new feature flag, add it to the FeatureFlags const and export a hook here
// export const useIsHelloWorldEnabled = () => useFeatureFlagEnabled(FeatureFlags.HELLO_WORLD_FEATURE)

// TODO: investigate posthog issue: https://linear.app/ecoplanet/issue/EC-4097/investigate-posthog-feature-flags-not-loaded
export const useIsQuantifiableMeasuresFeatureEnabled = () => true

export const useIsBatchAnalysisEnabled = () => useFeatureFlagEnabled(FeatureFlags.BATCH_ANALYSIS)

export const useIsCostForecastingEnabled = () => {
  return isLocal() || isBase()
}

export const useIsNewProcurementModuleEnabled = () => {
  const isEnabled = useFeatureFlagEnabled(FeatureFlags.LOAD_PLANNING_MEASURE_SIMULATION)
  const isProcurementUpsellingEnabled = useIsProcurementUpsellingEnabled()
  const isDevelopmentEnv = isLocal() || isBase()
  return isEnabled || isDevelopmentEnv || isProcurementUpsellingEnabled
}

export const useIsNewLiveMarketEnabled = () => {
  const isEnabled = useFeatureFlagEnabled(FeatureFlags.LOAD_PLANNING_MEASURE_SIMULATION)
  const isDevelopmentEnv = isLocal() || isBase()
  return isEnabled || isDevelopmentEnv
}

export const useIsProcurementUpsellingEnabled = () => {
  const isEnabled = useFeatureFlagEnabled(FeatureFlags.PROCUREMENT_UPSELLING)
  const isDevelopmentEnv = isLocal() || isBase()
  const isProcurementModuleEnabled = useIsProcurementModuleEnabled()
  return (isEnabled || isDevelopmentEnv) && !isProcurementModuleEnabled
}

export const useIsEnergyMarketsPageExtensionEnabled = () => useFeatureFlagEnabled(FeatureFlags.ENERGY_MARKETS_PAGE_EXTENSION)

export const useIsLegacyInsightsNavEnabled = () => useFeatureFlagEnabled(FeatureFlags.LEGACY_INSIGHTS_NAV)

export const useIsAtlasEnabled = () => useFeatureFlagEnabled(FeatureFlags.ATLAS)

// Temporarily keep the Atlas meter overview on the legacy Messstellen list.
export const useIsAtlasMeterOverviewEnabled = () => false

// EC-5827: surfaces EnPI as the last Messstellen tab instead of under Maßnahmen
export const useIsEasyOfferEnpiEnabled = (): boolean => useFeatureFlagEnabled(FeatureFlags.EASY_OFFER_ENPI) ?? false

export const useIsEasyOfferDashboardEnabled = (): boolean => useFeatureFlagEnabled(FeatureFlags.EASY_OFFER_DASHBOARD) ?? false

export const useIsCustomReferenceBaseLoadEnabled = (): boolean => useFeatureFlagEnabled(FeatureFlags.CUSTOM_REFERENCE_BASE_LOAD) ?? false

export const useIsNewInvoiceCostCalculationEnabled = (): boolean =>
  useFeatureFlagEnabled(FeatureFlags.NEW_INVOICE_COST_CALCULATION) ?? false

export const useIsInsightSettingsCardEnabled = (): boolean => useFeatureFlagEnabled(FeatureFlags.AUTOMATED_INSIGHTS) ?? false
